// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1bDLS","footer":"ModalError_footer__2zdGs"};